import React from 'react';

import { Skeleton } from '@rbilabs/universal-components';

import { Container as MarketingCardsContainer } from 'components/features/components/marketing-card-group/styled';
import { ButtonWrapper, CardWrap, TextWrapper } from 'components/ucl/card/styled';
import { Box } from 'components/ui';
import { useIsMobileBreakpoint } from 'hooks/use-media-query';
import { getDesignToken } from 'styles/constants';

const SKELETON_COUNT = 4;

const MarketingTileWrapper = ({ isMobile }: { isMobile: boolean }) => (
  <CardWrap
    bg={getDesignToken('background-card')}
    flexBasis={isMobile ? '100%' : '49%'}
    flexGrow={0}
    flexShrink={1}
  >
    <Box style={styles.imageContainer}>
      <Skeleton flex={1} />
    </Box>
    <TextWrapper>
      <Skeleton.Text
        lines={2}
        _line={{
          height: '20px',
        }}
      />
      <ButtonWrapper>
        <Skeleton height="30px" width="135px" rounded="2xl" />
      </ButtonWrapper>
    </TextWrapper>
  </CardWrap>
);

export const MarketingTileSkeleton = () => {
  const isMobile = useIsMobileBreakpoint();

  return (
    <MarketingCardsContainer testID="marketing-tile-skeleton-loader">
      {Array.from({ length: SKELETON_COUNT }, (_, index) => (
        <MarketingTileWrapper key={index} isMobile={isMobile} />
      ))}
    </MarketingCardsContainer>
  );
};

const styles = {
  imageContainer: {
    width: '100%' as const,
    aspectRatio: 2,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    overflow: 'hidden' as const,
  },
};
